import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { UserGetUser } from '@src/services/api-client'

function UserNameNoAuth({ id, siteId }) {
  const [data, setData] = useState(undefined)
  useEffect(() => {
    if (!id) {
      setData(undefined)
      return
    }

    UserGetUser(
      { userId: id, siteId },
      {
        cache: {
          ttl: 60000 * 10,
        },
      },
    ).then((res) => {
      setData(res.data)
    })
  }, [id])

  return <span>{data?.name}</span>
}

UserNameNoAuth.propTypes = {
  id: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
}

export { UserNameNoAuth }
